import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const GoBackToMyCertificatesButton = (): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Button
      className='justify-content-center p-0 mt-2 max-w-fit text-sm'
      text
      icon='pi pi-arrow-circle-left'
      onClick={() => {
        return navigate('/certificates/my-certificates');
      }}
      label={t('certificateDetailsPage.buttons.goBackToMyCertificates')}
    />
  );
};

export default GoBackToMyCertificatesButton;
